var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducatin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 34.3687V42.525C48.75 45.4875 47.0062 48.1313 44.3062 49.3687C41.025 50.8687 36.0562 52.5 30 52.5C23.9438 52.5 18.975 50.8687 15.675 49.3687C12.9937 48.1313 11.25 45.4875 11.25 42.525V34.3687L24.5812 40.4625C26.2875 41.25 28.125 41.6437 30 41.6437C31.875 41.6437 33.7125 41.25 35.4187 40.4625L48.75 34.3687ZM56.25 30.9375V43.125C56.25 44.1562 55.4062 45 54.375 45C53.3438 45 52.5 44.1562 52.5 43.125V32.6625L56.25 30.9375Z",
    fill: "#8A49D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1337 37.0574C27.3473 37.6117 28.6658 37.8986 30 37.8986C31.3342 37.8986 32.6527 37.6117 33.8662 37.0574L57.8119 26.1112C59.1619 25.4943 60 24.1874 60 22.7005C60 21.2137 59.1619 19.9049 57.8119 19.288L33.8662 8.34366C32.6533 7.78855 31.3349 7.50122 30.0009 7.50122C28.667 7.50122 27.3486 7.78855 26.1356 8.34366L2.18813 19.2862C0.838125 19.9049 0 21.2118 0 22.6987C0 24.1855 0.838125 25.4924 2.18813 26.1112L26.1337 37.0574Z",
    fill: "#8A49D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducatin);
export default __webpack_public_path__ + "static/media/educatin.265907f3dbbe9c2def7520e72a0ce7ae.svg";
export { ForwardRef as ReactComponent };